const contextPath = 'obpm/api';
export default contextPath;